export default __webpack_public_path__ + "static/media/ovary_dist.70f7475c.png";